/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Payment_Choice_Modal_Pay_Now_TitleInputs */

const es_components_payment_choice_modal_pay_now_title = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Now_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar ahora`)
};

const en_components_payment_choice_modal_pay_now_title = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Now_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay now`)
};

/**
* | output |
* | --- |
* | "Pay now" |
*
* @param {Components_Payment_Choice_Modal_Pay_Now_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_payment_choice_modal_pay_now_title = /** @type {((inputs?: Components_Payment_Choice_Modal_Pay_Now_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Payment_Choice_Modal_Pay_Now_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_payment_choice_modal_pay_now_title(inputs)
	return en_components_payment_choice_modal_pay_now_title(inputs)
});
export { components_payment_choice_modal_pay_now_title as "components.payment_choice_modal.pay_now_title" }